import { api, unwrap } from '../../shared/api/client';
import type { components } from '../../shared/api/schema.gen';

export type TCredential = components['schemas']['CredentialResDto'];
export type TCredentialUsage = components['schemas']['CredentialUsageResDto'];
export type TCredentialUse = components['schemas']['CredentialUseDto'];
export type TCredentialCheck = components['schemas']['CredentialCheckDto'];
export type TCredentialSaved = components['schemas']['CredentialSavedResDto'];
export type TCredentialCreate = components['schemas']['CreateCredentialReqDto'];
export type TCredentialUpdate = components['schemas']['UpdateCredentialReqDto'];
export type TConnector = components['schemas']['ConnectorDto'];
export type TConnectorField = components['schemas']['NodeFieldDto'];

export const listCredentials = async (): Promise<TCredential[]> =>
  (await unwrap(api.GET('/v1/credentials'))).data;

/** "Check" before saving: signs in with the fields, stores nothing. */
export const testCredential = (
  connectorKey: string,
  fields: Record<string, unknown>,
): Promise<TCredentialCheck> =>
  unwrap(api.POST('/v1/credentials/test', { body: { connectorKey, fields } }));

/** Saved even when its check fails; `check` says how it went. */
export const createCredential = (body: TCredentialCreate): Promise<TCredentialSaved> =>
  unwrap(api.POST('/v1/credentials', { body }));

/** "Replace the password": the fields lay over the stored ones, the id stays. */
export const updateCredential = (id: string, body: TCredentialUpdate): Promise<TCredentialSaved> =>
  unwrap(api.PATCH('/v1/credentials/{id}', { params: { path: { id } }, body }));

export const checkCredential = (id: string): Promise<TCredentialSaved> =>
  unwrap(api.POST('/v1/credentials/{id}/check', { params: { path: { id } } }));

export const removeCredential = async (id: string): Promise<void> => {
  await unwrap(api.DELETE('/v1/credentials/{id}', { params: { path: { id } } }));
};

export const listConnectors = async (): Promise<TConnector[]> =>
  (await unwrap(api.GET('/v1/flows/node-types'))).connectors;

// `['credentials']` is the editor's key too (entities/flow): one invalidation refreshes both.
export const credentialKeys = {
  all: ['credentials'] as const,
  list: ['credentials', 'list'] as const,
  connectors: ['connectors'] as const,
};
